import type { SearchMenuItemProps } from "./types-item";
import { useSearchMenuItem } from "./use-item";
import { SearchMenuItemView } from "./view-item";

export function SearchMenuItem(props: SearchMenuItemProps) {
  const viewModel = useSearchMenuItem(props);

  return <SearchMenuItemView {...viewModel} />;
}
SearchMenuItem.displayName = "SearchMenu.Item";
